import { React, useEffect, useRef } from "react";
import { createPopup } from "./scripts/popup";

import emailjs from "@emailjs/browser";

const ContactUs = () => {
  const form = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleKeyUp = (e) => {
    e.target.value = e.target.value.replace(/[^0-9+]/g, "");
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_wyyc06r",
        "template_gy2jqfe",
        form.current,
        "w69Y_igKHkkPHsLUe"
      )
      .then(
        (result) => {
          console.log(result.text);
          createPopup('Thank you for message')
        },
        (error) => {
          console.log(error.text);
          createPopup('Error')
        }
      );
    document.formData.reset(); 
  };


  return (
    <section className="container">
      <div className="contact-us-page">
        <div className="hero">
          <h3>We're all ears</h3>
          <h1 className="hero-title">
          Fill out the form to start the conversation — we’ll get right back to you
          </h1>
        </div>
      </div>
      <div className="contact-us contact-us-forum">
        <div className="columns">
          <div className="item"></div>
        </div>
        <form name="formData" autoComplete="off" ref={form} onSubmit={sendEmail}>
          <h1>Let’s talk</h1>
          <div className="data">
            <div className="forums">
              <div className="name-email-box">
                <input
                  className="name"
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Name"
                  required
                />
                <input
                  className="email"
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Email"
                  required
                />
              </div>
              <input
                type="text"
                name="phone"
                id="phone"
                placeholder="Phone"
                onKeyUp={handleKeyUp}
              />
              <input
                type="text"
                name="company-name"
                id="company-name"
                placeholder="Company name"
              />
              <textarea
                name="message"
                id="message"
                cols="20"
                rows="5"
                maxLength="1000"
                placeholder="Tell us a little about your project"
              ></textarea>
              <div className="btn" >
                <button type="submit" className="button" >
                  <p>Send message</p>{" "}
                  <span>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.4569 0.218899C19.8515 0.492337 20.0585 0.964993 19.9843 1.43765L17.4843 17.6876C17.4257 18.0666 17.1952 18.3986 16.8593 18.5861C16.5234 18.7736 16.121 18.797 15.7655 18.6486L11.0937 16.7072L8.41789 19.6017C8.07023 19.9806 7.52336 20.1056 7.04289 19.9181C6.56242 19.7306 6.24992 19.2658 6.24992 18.7501V15.4845C6.24992 15.3283 6.30851 15.1798 6.41398 15.0666L12.9609 7.92202C13.1874 7.67593 13.1796 7.29702 12.9452 7.06265C12.7109 6.82827 12.3319 6.81265 12.0859 7.03531L4.14054 14.0939L0.691325 12.3673C0.277262 12.1603 0.0116373 11.7462 -8.1424e-05 11.2853C-0.0118002 10.8244 0.230387 10.3947 0.628825 10.1642L18.1288 0.164212C18.5468 -0.0740694 19.0624 -0.0506319 19.4569 0.218899Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
            <div className="details">
              <div className="item">
                <span>PHONE :</span>
                <p>+373 60 531017</p>
              </div>
              <div className="item">
                <span>EMAIL :</span>
                <p>maxim.ciubari@outlook.com</p>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ContactUs;
